import React from 'react';
import { FragmentType, graphql, useFragment } from '@frontend/gql/social';
import { CardStat, CardStatLabel, CardStatRow } from '../../../../components/card-stat';
import { MetricChangeIndicator } from '../../../../components/metric-change-indicator';
import { formatNumber } from '../../../../utils/formatNumber';

const reachFragment = graphql(`
  fragment Reach_MetaSumInsights on MetaSumInsights {
    totalReach
  }
`);

type ReachProps = {
  currentInterval: FragmentType<typeof reachFragment> | null | undefined;
  previousInterval: FragmentType<typeof reachFragment> | null | undefined;
};

export const Reach = ({ currentInterval, previousInterval }: ReachProps) => {
  const currentIntervalData = useFragment(reachFragment, currentInterval);
  const previousIntervalData = useFragment(reachFragment, previousInterval);

  const currentReach = currentIntervalData?.totalReach ?? 0;
  const previousReach = previousIntervalData?.totalReach ?? 0;

  return (
    <div className="space-y-2">
      <CardStatRow>
        <CardStat className="text-xl leading-none">{formatNumber(currentReach)}</CardStat>
        <MetricChangeIndicator current={currentReach} previous={previousReach} showTimeRange={false} />
      </CardStatRow>
      <CardStatLabel>Reach</CardStatLabel>
    </div>
  );
};
